import React from 'react';

const MeetingCard = ({ meeting }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('sv-SE', { 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getTypeDisplay = (type) => {
    if (!type || type === '-') return '';
    return type.split(', ').map(t => t.trim()).join(' + ');
  };

  const getMeetingTypeClass = (type) => {
    if (!type || type === '-') return '';
    if (type.includes('D')) return 'druid';
    if (type.includes('B')) return 'bard';
    if (type.includes('Eu')) return 'eubat';
    return '';
  };

  const hasImportantInfo = (meeting) => {
    return meeting.dresscode === 'Frack' || 
           meeting.meeting.includes('DGG') || 
           meeting.meeting.includes('BGG') ||
           meeting.meeting.includes('Rec');
  };

  const isBardalandMeeting = (meeting) => {
    return !meeting.region; // Bardaland meetings have no region field
  };

  const isJarnbaralandMeeting = (meeting) => {
    return meeting.region === 'Järnbäraland';
  };

  const isFolkungalandMeeting = (meeting) => {
    return meeting.region === 'Folkungaland';
  };

  return (
    <div className={`meeting-card ${getMeetingTypeClass(meeting.type)} ${hasImportantInfo(meeting) ? 'important' : ''} ${isBardalandMeeting(meeting) ? 'bardaland' : ''} ${isJarnbaralandMeeting(meeting) ? 'jarnbaraland' : ''} ${isFolkungalandMeeting(meeting) ? 'folkungaland' : ''}`}>
      <div className="meeting-header">
        <div className="meeting-date">
          <span className="date">{formatDate(meeting.date)}</span>
          <span className="weekday">{meeting.weekday}</span>
        </div>
        <div className="meeting-time">
          {meeting.time !== '-' ? meeting.time : ''}
        </div>
      </div>
      
      <div className="meeting-main">
        <div className="meeting-lodge">
          <strong>{meeting.lodge}</strong>
          {meeting.city && meeting.city !== '-' && (
            <span className="city"> • {meeting.city}</span>
          )}
        </div>
        
        {meeting.type && meeting.type !== '-' && (
          <div className="meeting-type">
            <span className="type-badge">{getTypeDisplay(meeting.type)}</span>
            {meeting.dresscode && meeting.dresscode !== '-' && (
              <span className="dresscode">{meeting.dresscode}</span>
            )}
          </div>
        )}
        
        {meeting.meeting && meeting.meeting !== '-' && (
          <div className="meeting-special">
            <span className="meeting-badge">{meeting.meeting}</span>
          </div>
        )}
        
        {meeting.details && meeting.details !== '-' && (
          <div className="meeting-details">
            {meeting.details}
          </div>
        )}
        
        {meeting.place && meeting.place !== '-' && (
          <div className="meeting-place">
            📍 {meeting.place}
          </div>
        )}
      </div>
    </div>
  );
};

export default MeetingCard;